import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import config from "../../../config/config";
import { BiFootball } from "react-icons/bi";

export const GoalScoreCard = ({ data }) => {
  const { i18n } = useTranslation();

  return (
    <div className="w-full flex flex-col gap-2 px-2 py-2">
      {data?.map((event, k) => (
        <div
          key={k}
          className={`
            w-full rounded-xl border
            border-gray-200 dark:border-gray-700
            bg-white dark:bg-bg_header_dark
            shadow-sm hover:shadow-md
            transition
          `}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100 dark:border-gray-700">
            <span className="text-xs font-medium px-2 py-0.5 rounded-full
              bg-bg_league text-black dark:bg-slate-300">
              {event?.league}
            </span>

            <span className="text-[11px] text-gray-500 dark:text-gray-400">
              {moment(event?.event).format("DD MMM YYYY • h:mm A")}
            </span>
          </div>

          {/* Body */}
          <div className="flex items-center justify-between px-3 py-4 font-myanmarSansPro">
            {/* Home */}
            <div className="w-[40%] text-right pr-2">
              <p className="text-sm font-medium truncate">
                {i18n.language === "en"
                  ? event?.homeTeam
                  : event?.homeTeamMyan}
              </p>
            </div>

            {/* Score */}
            <div className="flex flex-col items-center min-w-[70px]">
              <div className="flex items-center gap-1 font-dangrek font-semibold">
                <span>{event?.homeGoal}</span>
                <BiFootball size={14} className="opacity-70" />
                <span>{event?.awayGoal}</span>
              </div>
              <span className="text-[11px] text-content">
                {config.goal_status[event?.status]}
              </span>
            </div>

            {/* Away */}
            <div className="w-[40%] text-left pl-2">
              <p className="text-sm font-medium truncate">
                {i18n.language === "en"
                  ? event?.awayTeam
                  : event?.awayTeamMyan}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
